export default __webpack_public_path__ + "static/media/mood.77c1177f.svg";